import { fromEventPattern, Observable } from 'rxjs';

export const eventFromPatternTinyMCE = (editor, eventName: string): Observable<any> => {
  let a = handler => {
    editor.on(eventName, handler);
  };
  return fromEventPattern(a);
};
